import Button from '@mui/material/Button';

export default function EwpButton({children,fullWidth,complete,...props}) {
    fullWidth = (fullWidth !== undefined) ? fullWidth : true;
    complete = (complete !== undefined) ? complete : false;

    return (
        <Button fullWidth variant="contained" color={(complete) ? "overdue": "primary"} {...props}>{children}</Button>
    );
}